import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  inject,
  OnInit,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-tab-button',
  templateUrl: './tab-button.component.html',
  styleUrls: ['./tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabButtonComponent implements OnInit {
  @Input({ required: true }) label!: string;
  @Input() isSelected = true;
  @Output() clickEvent = new EventEmitter<void>();

  themeService = inject(ThemeService);

  hasShadow = false;

  ngOnInit() {
    this.hasShadow = this.themeService.buttonConfig().primary.shadow;
  }

  onClick(event: MouseEvent | TouchEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
